export const adminEn = {
    title: 'Administration',
    filter: {
        organization: 'Organization',
        allOrganizations: 'All organizations'
    },
    orders: {
        title: 'Orders',
        list: 'Orders list — all organizations'
    },
    templates: {
        title: 'Print Templates',
        list: 'Print templates list — all organizations'
    },
    customers: {
        title: 'Customers',
        list: 'Customers list — all organizations'
    },
    products: {
        title: 'Products',
        list: 'Products list — all organizations'
    }
}
